import { render } from "./PaperTable.vue?vue&type=template&id=3ae9228c&scoped=true"
import script from "./PaperTable.vue?vue&type=script&lang=js"
export * from "./PaperTable.vue?vue&type=script&lang=js"

import "./PaperTable.vue?vue&type=style&index=0&id=3ae9228c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ae9228c"]])

export default __exports__